import { AddHeroCard } from "@/components/add-card/AddHeroCard";
import { AddTextCard } from "@/components/add-card/AddTextCard";
import { AddLinkCard } from "@/components/add-card/AddLinkCard";
import { AddImageCard } from "@/components/add-card/AddImageCard";
import { AddFeatureCard } from "@/components/add-card/AddFeatureCard";
import { AddFaqCard } from "@/components/add-card/AddFaqCard";
import { AddWhatsappCard } from "@/components/add-card/AddWhatsappCard";
import { AddTippingCard } from "@/components/add-card/AddTippingCard";
import type { CommonColor } from "@stackje/common/config";

export type CardComponentConfig = {
  getComponents: (defaultColors: CommonColor) => {
    formContent: React.ReactNode;
    previewContent: React.ReactNode;
    hasCustomPreviewButtons?: boolean;
    toggleType?: (type?: string) => void;
    shuffleColors?: () => void;
    handleSubmit: (onSubmit: (data: Record<string, unknown>) => void | Promise<void>) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  };
};

export const cardComponentRegistry: Record<string, CardComponentConfig> = {
  hero: {
    getComponents: (defaultColors: CommonColor) => {
      const HeroAdd = AddHeroCard("hero1", defaultColors);
      return {
        formContent: HeroAdd.formContent,
        previewContent: HeroAdd.previewContent,
        hasCustomPreviewButtons: true,
        toggleType: HeroAdd.toggleType,
        shuffleColors: HeroAdd.shuffleColors,
        handleSubmit: HeroAdd.handleSubmit,
      };
    },
  },
  text: {
    getComponents: (defaultColors: CommonColor) => {
      const TextAdd = AddTextCard("text1", defaultColors);
      return {
        formContent: TextAdd.formContent,
        previewContent: TextAdd.previewContent,
        shuffleColors: TextAdd.shuffleColors,
        handleSubmit: TextAdd.handleSubmit,
      };
    },
  },
  links: {
    getComponents: (defaultColors: CommonColor) => {
      const LinkAdd = AddLinkCard("link1", defaultColors);
      return {
        formContent: LinkAdd.formContent,
        previewContent: LinkAdd.previewContent,
        toggleType: LinkAdd.toggleType,
        shuffleColors: LinkAdd.shuffleColors,
        handleSubmit: LinkAdd.handleSubmit,
      };
    },
  },
  images: {
    getComponents: (defaultColors: CommonColor) => {
      const ImageAdd = AddImageCard("image1", defaultColors);
      return {
        formContent: ImageAdd.formContent,
        previewContent: ImageAdd.previewContent,
        toggleType: ImageAdd.toggleType,
        shuffleColors: ImageAdd.shuffleColors,
        handleSubmit: ImageAdd.handleSubmit,
      };
    },
  },
  features: {
    getComponents: (defaultColors: CommonColor) => {
      const FeatureAdd = AddFeatureCard("feature1", defaultColors);
      return {
        formContent: FeatureAdd.formContent,
        previewContent: FeatureAdd.previewContent,
        toggleType: FeatureAdd.toggleType,
        shuffleColors: FeatureAdd.shuffleColors,
        handleSubmit: FeatureAdd.handleSubmit,
      };
    },
  },
  faq: {
    getComponents: (defaultColors: CommonColor) => {
      const FaqAdd = AddFaqCard("faq1", defaultColors);
      return {
        formContent: FaqAdd.formContent,
        previewContent: FaqAdd.previewContent,
        toggleType: FaqAdd.toggleType,
        shuffleColors: FaqAdd.shuffleColors,
        handleSubmit: FaqAdd.handleSubmit,
      };
    },
  },
  whatsapp: {
    getComponents: (defaultColors: CommonColor) => {
      const WhatsappAdd = AddWhatsappCard("whatsapp1", defaultColors);
      return {
        formContent: WhatsappAdd.formContent,
        previewContent: WhatsappAdd.previewContent,
        toggleType: WhatsappAdd.toggleType,
        shuffleColors: WhatsappAdd.shuffleColors,
        handleSubmit: WhatsappAdd.handleSubmit,
      };
    },
  },
  tipping: {
    getComponents: (defaultColors: CommonColor) => {
      const TippingAdd = AddTippingCard("tipping1", defaultColors);
      return {
        formContent: TippingAdd.formContent,
        previewContent: TippingAdd.previewContent,
        toggleType: TippingAdd.toggleType,
        shuffleColors: TippingAdd.shuffleColors,
        handleSubmit: TippingAdd.handleSubmit,
      };
    },
  },
};
